<template>
  <v-row align="center">
    <v-col class="shrink pr-2" align-self="start">
      <v-icon>{{ icon }}</v-icon>
    </v-col>
    <v-col class="grow">
      <vs-text v-if="type === 'destination'">
        <span>{{ locationName }}</span>
      </vs-text>
      <vs-text v-if="type === 'pickup'">
        <span v-if="locationName">{{ locationName }}</span>
        <span v-else>Pick up location undecided</span>
      </vs-text>
      <slot name="after" />
    </v-col>
    <slot name="edit-button" />
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import VsText from '@/components/vision/VsText.vue'

const props = defineProps<{
  locationName?: string | null
  type: 'pickup' | 'destination'
}>()

const icon = computed(() => {
  if (props.type === 'pickup') {
    return 'mdi-map-marker'
  } else {
    return 'mdi-flag'
  }
})
</script>
